/**
 * Calculates the amount including Tax.
 *
 * @param {number} amount - The original amount excluding VAT.
 * @param {number|undefined} tax.
 * @returns {number} The amount including VAT.
 */
export function amountIncludingTax(amount, tax = undefined) {
    return amount + taxOfAmount(amount, tax);
}

/**
 * Calculates the amount excluding Tax.
 *
 * @param {number} amount - The original amount including VAT.
 * @param {number|undefined} tax.
 * @returns {number} The amount excluding VAT.
 */
export function amountExcludingTax(amount, tax = undefined) {
    return amount / ((100 + (tax ?? regionData.vat)) / 100);
}

/**
 * Calculates the Tax of a given amount.
 *
 * @param {number} amount - The original amount.
 * @param {number|undefined} tax.
 * @returns {number} The VAT portion of the amount.
 */
export function taxOfAmount(amount, tax = undefined) {
    return amount * ((tax ?? regionData.vat) / 100);
}

/**
 * @param {boolean} isPunter
 * @param {string|number} creditsToBuy
 * @param {number|undefined} tax.
 * @returns {number}
 */
export function getCreditsPriceTaxedByUserRole(isPunter, creditsToBuy, tax = undefined) {
    return !isPunter ? Number(creditsToBuy) : amountIncludingTax(parseFloat(creditsToBuy), tax);
}
